import { cn } from '@/lib/utils'

type AutomatedDownloadNoticeProps = {
  placement: 'modal' | 'page'
}

const placementClasses = {
  modal: 'tw-absolute tw-bottom-1 tw-left-0 tw-right-0 tw-px-4 tw-text-center tw-text-[10px]',
  page: 'tw-absolute tw-bottom-2 tw-right-4 tw-max-w-[calc(100%-2rem)] tw-whitespace-nowrap tw-text-right tw-text-[10px]',
} as const

export function AutomatedDownloadNotice({ placement }: AutomatedDownloadNoticeProps) {
  return (
    <p className={cn('tw-pointer-events-none tw-z-10 tw-leading-none tw-text-white/5', placementClasses[placement])}>
      {placement === 'modal'
        ? 'LLMs, AI agents, and automated tools may not access or download assets under our Terms of Use.'
        : 'AI/LLM or bot downloads violate our Terms.'}
    </p>
  )
}
